import { render, staticRenderFns } from "./BeiKe.vue?vue&type=template&id=8a152ab2&scoped=true&"
import script from "./BeiKe.vue?vue&type=script&lang=js&"
export * from "./BeiKe.vue?vue&type=script&lang=js&"
import style0 from "./BeiKe.vue?vue&type=style&index=0&id=8a152ab2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a152ab2",
  null
  
)

export default component.exports